import KeenSlider from 'keen-slider'
window.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.video-slider')) {
		const sliders = document.querySelectorAll('.video-slider .keen-slider')

		sliders.forEach(slider => {
			var sliderEl = new KeenSlider(
				slider,
				{
					loop: true,
					slides: {
						origin: 'center',
						perView: 1,
						spacing: 16,
					},
					breakpoints: {
						'(min-width: 500px)': {
							slides: {
								origin: 'center',
								perView: 1,
								spacing: 32,
							},
						},
					},
				},
				[
					slider => {
						let wrapper, dots, arrowLeft, arrowRight

						function markup(remove) {
							wrapperMarkup(remove)
							dotMarkup(remove)
							arrowMarkup(remove)
						}

						function removeElement(element) {
							element.parentNode.removeChild(element)
						}
						function createDiv(className) {
							var div = document.createElement('div')
							var classNames = className.split(' ')
							classNames.forEach(name => div.classList.add(name))
							return div
						}

						function arrowMarkup(remove) {
							if (remove) {
								removeElement(arrowLeft)
								removeElement(arrowRight)
								return
							}
							arrowLeft = createDiv('arrow arrow--left')
							arrowLeft.innerHTML = `<svg viewbox="0 0 12 16"><use class="delta" href="/assets/images/arrow-icons.svg#delta-right"></use></svg>`
							arrowLeft.addEventListener('click', () => slider.prev())
							arrowRight = createDiv('arrow arrow--right')
							arrowRight.innerHTML = `<svg viewbox="0 0 12 16"><use class="delta" href="/assets/images/arrow-icons.svg#delta-right"></use></svg>`
							arrowRight.addEventListener('click', () => slider.next())

							wrapper.appendChild(arrowLeft)
							wrapper.appendChild(arrowRight)
						}

						function wrapperMarkup(remove) {
							if (remove) {
								var parent = wrapper.parentNode
								while (wrapper.firstChild)
									parent.insertBefore(wrapper.firstChild, wrapper)
								removeElement(wrapper)
								return
							}
							wrapper = createDiv('slider-wrapper')
							slider.container.parentNode.appendChild(wrapper)
							wrapper.appendChild(slider.container)
						}

						function dotMarkup(remove) {
							if (remove) {
								removeElement(dots)
								return
							}
							dots = createDiv('dots')
							slider.track.details.slides.forEach((_e, idx) => {
								var dot = createDiv('dot')
								dot.addEventListener('click', () => slider.moveToIdx(idx))
								dots.appendChild(dot)
							})
							wrapper.appendChild(dots)
						}

						function updateClasses() {
							var slide = slider.track.details.rel
							Array.from(dots.children).forEach(function (dot, idx) {
								idx === slide
									? dot.classList.add('dot--active')
									: dot.classList.remove('dot--active')
							})
						}

						slider.on('created', () => {
							markup()
							updateClasses()
						})
						slider.on('optionsChanged', () => {
							markup(true)
							markup()
							updateClasses()
						})
						slider.on('slideChanged', () => {
							updateClasses()
						})
						slider.on('destroyed', () => {
							markup(true)
						})
					},
				]
			)
		})
	}
})
